"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),t=require("@vds-core/notifications"),r=require("./Notification.js");function i(e){return e&&e.__esModule?e:{default:e}}var n=i(e);exports.default=function(e){return n.default.createElement(t.NotificationContainer,Object.assign({},e,{renderNotification:r.default}))};



//////////////////
// WEBPACK FOOTER
// ./~/@vds/notifications/cjs/components/NotificationContainer.js
// module id = 1529
// module chunks = 0